import { createTypes } from "@/store/utils";

export const FETCH_IDENTITY = createTypes("IDENTITY");
export const UPDATE_ACCOUNT = createTypes("UPDATE_ACCOUNT");
export const REFRESH_API_TOKEN = createTypes("REFRESH_API_TOKEN");
export const UPDATE_SETTINGS = createTypes("UPDATE_SETTINGS");
export const FETCH_SETTINGS = createTypes("FETCH_SETTINGS");
export const UPDATE_USER = createTypes("UPDATE_USER");
export const FETCH_ACTIVITIES = createTypes("FETCH_ACTIVITIES");
export const UPDATE_ACCOUNT_IMAGE = createTypes("UPDATE_ACCOUNT_IMAGE");
